module.exports = "//static.hsappstatic.net/conversations-embed/static-1.26137/sass/messagesWidgetShell.sass"